import React from "react";
import '../RegistrationBtn/RegistrationBtn.scss';

export function RegistrationBtn() {
    return (
        <a href='/registration' className='registration__btn'>Зарегистрироваться</a>
    )
}